module.exports = __webpack_public_path__ + "static/the-alchemist-acef867f7bf66be4d943927b78cdc779.jpg";